export interface IPromoDataType {
  types: PromotionType[];
  media?: PromotionMediaObject;
  cart?: SelectedPackage[];
}

export type PromotionType =
  | "Radio Promotion"
  | "TV Promotion"
  | "Blog/Press Release";

export type PromotionMediaObject = Partial<{
  "Radio Promotion": string;
  "TV Promotion": string;
  "Blog/Press Release": {
    media: string;
    note: string;
    file: File | null;
  };
}>;

export const TypesArray: PromotionType[] = [
  "Radio Promotion",
  "TV Promotion",
  "Blog/Press Release"
];

export interface Station {
  name: string;
  location: string;
  listeners: string;
  type: "Radio" | "Tv" | "Press";
  packages: {
    id: string;
    name: string;
    price: string;
  }[];
}

export interface SelectedPackage {
  stationId: string;
  stationName: string;
  stationType: "Radio" | "Tv" | "Press";
  packageId: string;
  packageName: string;
  packagePrice: string;
}
